const MS_POR_MINUTO = 60000;
const MINUTOS_FORMATTER = new Intl.NumberFormat("pt-BR", {
  minimumFractionDigits: 0,
  maximumFractionDigits: 0
});

function toNumber(value) {
  const parsed = Number(value);
  return Number.isFinite(parsed) ? parsed : 0;
}

export function msParaMinutos(value) {
  return toNumber(value) / MS_POR_MINUTO;
}

export function formatMinutos(value) {
  return MINUTOS_FORMATTER.format(Math.round(toNumber(value)));
}

const MS_POR_HORA = 60 * MS_POR_MINUTO;

function pad(value) {
  return String(value).padStart(2, "0");
}

// Formata no padrão do input datetime-local (hora local do navegador)
function toDatetimeLocal(date) {
  return `${date.getFullYear()}-${pad(date.getMonth() + 1)}-${pad(date.getDate())}T${pad(
    date.getHours()
  )}:${pad(date.getMinutes())}`;
}

// Período da última hora, de (agora - 1h) até agora, na hora local do usuário
export function ultimaHoraLocal() {
  const agora = new Date();
  return {
    datainicial: toDatetimeLocal(new Date(agora.getTime() - MS_POR_HORA)),
    datafinal: toDatetimeLocal(agora)
  };
}

// Converte datainicial/datafinal (hora local do input) para ISO/UTC, independente do fuso
export function periodoParaISO({ datainicial, datafinal }) {
  return {
    datainicial: new Date(datainicial).toISOString(),
    datafinal: new Date(datafinal).toISOString()
  };
}
